<template>
    <div class="tunnelshare-box">
      <img class="ts-bg" src="@/assets/images/couponTunnel/otherbg.png" alt="">
      <div class="ts-box">
        <div class="ts-btn">
          <img @click="handleJoin" src="@/assets/images/couponTunnel/joinbtn.png" alt="">
        </div>
        <div class="ts-rule">
          <img src="@/assets/images/couponTunnel/otherrule.png" alt="">
        </div>
      </div>
    </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'tunnelShare',
  data () {
    return {
    }
  },
  methods: {
    handleJoin () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '隧e通8910优惠券', '我要参与-隧e通', '我要参与-隧e通', '我要参与', '003'])
      }
      let ua = navigator.userAgent.toLowerCase()
      let isWeixin = ua.indexOf('micromessenger') !== -1
      if (isWeixin) {
        Toast({
          message: '请在右上角选择在浏览器打开'
        })
        return
      }
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    }
  }
}
</script>
<style lang='scss' scoped>
.tunnelshare-box {
  position: relative;
  font-size: 0;
  .ts-bg {
    width: 100%;
  }
  .ts-box {
    position: absolute;
    bottom: 1%;
  }
  .ts-btn {
    width: 70%;
    margin: 15px auto;
    img {
      width: 100%;
    }
  }
  .ts-rule {
    margin: 15px;
    img {
      width: 100%;
    }
  }
}
</style>
